<div style="display: block; height: 350px; width: 100%">
	<canvas baseChart [data]="lineChartData" [labels]="lineChartLabels" [options]="lineChartOptions" [legend]="lineChartLegend" [plugins]="lineChartPlugins" [type]="lineChartType"></canvas>
</div>
